/**
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 会員管理画面の共有定数。サブスクステータスとレンタルステータスのスタイル定義を一元管理する。
 * @graph-connects none
 */

import { RENTAL_STATUS_LABELS } from '@cortex/domain-ac-mens-hub-api';

/** @graph-connects none */
export const STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  active: { bg: 'var(--color-success-bg)', text: 'var(--color-success)', label: 'active' },
  waiting: { bg: 'var(--color-info-bg)', text: 'var(--color-info)', label: 'waiting' },
  cancel_requested: {
    bg: 'var(--color-warning-bg)',
    text: 'var(--color-warning)',
    label: 'cancel_requested',
  },
  canceled: { bg: 'var(--color-error-bg)', text: 'var(--color-error)', label: 'canceled' },
};

/**
 * レンタルステータスの色。状態そのものではなく「何が起きているか」で色をまとめる。
 *
 * 一覧はレンタル中と配送完了で大半が埋まるため、状態ごとに色を散らすと逆に読めなくなる。
 * 「社内の作業待ち」「物が動いている」「稼働中」「終わった」で色を共有し、
 * 全体の 83% を占める「オーダーなし」は最も弱い色にして他の状態を埋もれさせない。
 *
 * @graph-connects none
 */
export const RENTAL_STATUS_STYLES: Record<string, { bg: string; text: string }> = {
  // 未利用。件数が最も多いので最も目立たない色にする
  [RENTAL_STATUS_LABELS.noOrder]: {
    bg: 'transparent',
    text: 'var(--color-text-disabled)',
  },
  // 社内の作業待ち
  [RENTAL_STATUS_LABELS.request]: {
    bg: 'var(--color-warning-bg)',
    text: 'var(--color-warning)',
  },
  [RENTAL_STATUS_LABELS.styling]: {
    bg: 'var(--color-warning-bg)',
    text: 'var(--color-warning)',
  },
  [RENTAL_STATUS_LABELS.stylingConfirm]: {
    bg: 'var(--color-warning-bg)',
    text: 'var(--color-warning)',
  },
  [RENTAL_STATUS_LABELS.stylingCompleted]: {
    bg: 'var(--color-warning-bg)',
    text: 'var(--color-warning)',
  },
  // 物が動いている
  [RENTAL_STATUS_LABELS.preparing]: {
    bg: 'var(--color-info-bg)',
    text: 'var(--color-info)',
  },
  [RENTAL_STATUS_LABELS.shipping]: {
    bg: 'var(--color-info-bg)',
    text: 'var(--color-info)',
  },
  [RENTAL_STATUS_LABELS.awaitingReceipt]: {
    bg: 'var(--color-info-bg)',
    text: 'var(--color-info)',
  },
  [RENTAL_STATUS_LABELS.returnRequested]: {
    bg: 'var(--color-info-bg)',
    text: 'var(--color-info)',
  },
  [RENTAL_STATUS_LABELS.returnChecking]: {
    bg: 'var(--color-info-bg)',
    text: 'var(--color-info)',
  },
  // 稼働中
  [RENTAL_STATUS_LABELS.renting]: {
    bg: 'var(--color-success-bg)',
    text: 'var(--color-success)',
  },
  // 終わった
  [RENTAL_STATUS_LABELS.delivered]: {
    bg: 'var(--color-bg-elevated)',
    text: 'var(--color-text-secondary)',
  },
  [RENTAL_STATUS_LABELS.canceled]: {
    bg: 'var(--color-error-bg)',
    text: 'var(--color-error)',
  },
};
